/**
 * Custom Built Tool Helper Functions
 * Contains validation and utility functions for custom built AI tools
 */

import { ASR_URL_PATTERN, SecurityReviewSystem, TALOS_URL_PATTERN } from "../constants/platform-constants";
const ASR_REGEX = new RegExp(ASR_URL_PATTERN);
const TALOS_REGEX = new RegExp(TALOS_URL_PATTERN);

/**
 * Detects whether a URL is an ASR or Talos link
 * @param url - The URL to analyze
 * @returns SecurityReviewSystem enum value
 */
export const detectLinkType = (url: string): SecurityReviewSystem => {
  if (!url || typeof url !== "string") {
    return SecurityReviewSystem.OTHER;
  }

  const trimmedUrl = url.trim();

  if (isValidAsrLink(trimmedUrl)) {
    return SecurityReviewSystem.ASR;
  }

  if (isValidTalosLink(trimmedUrl)) {
    return SecurityReviewSystem.TALOS;
  }

  return SecurityReviewSystem.OTHER;
};

/**
 * Validates if a URL is a valid ASR link
 * @param url - The URL to validate
 * @returns boolean indicating if it's a valid ASR link
 */
export const isValidAsrLink = (url: string): boolean => {
  return ASR_REGEX.test(url);
};

/**
 * Validates if a URL is a valid Talos link
 * @param url - The URL to validate
 * @returns boolean indicating if it's a valid Talos link
 */
export const isValidTalosLink = (url: string): boolean => {
  return TALOS_REGEX.test(url);
};
